import { BaseContainerModel } from '../../../base-container.model';
import {
  bl_alg_cc_task_campaign_link_RowClass,
  bl_alg_cc_task_campaign_link_RowInterface,
} from '../../../../dbschema';

export class TaskCampaignLinkContainerModel extends BaseContainerModel {
  bl_alg_cc_task_campaign_link: bl_alg_cc_task_campaign_link_RowInterface =
    new bl_alg_cc_task_campaign_link_RowClass();
}
